/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type ReportingMetrics from 'embercom/services/reporting-metrics';

export default class StandaloneTasksIndexRoute extends Route {
  @service declare intl: IntlService;
  @service declare reportingMetrics: ReportingMetrics;

  get titleToken() {
    return this.intl.t('ai-agent.train.tasks');
  }

  async beforeModel() {
    await this.reportingMetrics.loadMetricsAndProperties();
  }
}
